export type FullscreenSupport = 'standard' | 'video-only' | 'none'

export function getFullscreenSupport(): FullscreenSupport {
  if (document.fullscreenEnabled) return 'standard'
  if ('webkitEnterFullscreen' in HTMLVideoElement.prototype) return 'video-only'
  return 'none'
}
